import { all, call } from 'redux-saga/effects'
import lineDetailsSaga from './../LineDetails/sagas'
import NameCardSaga from './../common/NumberCard/saga/index'
import SharedLineSaga from './../common/NumberCard/saga/sharedLineSaga'
import LineDelveSaga from 'app/LineDelve/sagas'
import manageDevicesSaga from 'app/ManageDevices/sagas'

// initial starting point of sagas
//todo : need to rull all imported module sagas insted of one
export default function* rootSaga() {
  yield all([
    call(lineDetailsSaga),
    call(NameCardSaga),
    call(LineDelveSaga),
    call(SharedLineSaga),
    call(manageDevicesSaga),
  ])
}
